module.exports = __webpack_public_path__ + "img/emoji_107.ba3ecc86.png";